import { forwardRef } from 'react';
import type { View } from 'react-native';

import { Button, HStack, Text, VStack, theme } from '@squire/ui';

import { UserAddIcon, UserDeniedIcon } from '@/components/_icons';
import { Card } from '@/components/_shared/Card';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { AddAppointmentButtonCardProps } from './types';

const AddAppointmentButtonCard = forwardRef<
  View,
  AddAppointmentButtonCardProps
>(({ canAddGuest, onAddAppointment, testID }, ref) => {
  const { t } = useScreenTranslations('ViewOrderBottomSheet');

  return (
    <Card ref={ref} style={styles.card} testID={testID} variant="outlined">
      <HStack
        centerVertical
        padding={theme.spacing[4]}
        space={theme.spacing[5]}
      >
        {canAddGuest ? (
          <>
            <UserAddIcon color="cartTextPrimary" />
            <VStack flex>
              <Text variant="lStrong" color="cartTextPrimary">
                {t('addGuest')}
              </Text>
              <Text variant="s" color="cartTextPrimary">
                {t('checkoutAllAtOnce')}
              </Text>
            </VStack>

            {!!onAddAppointment && (
              <Button
                onPress={onAddAppointment}
                accessibilityLabel={t('accessibility.addGuestButton')}
              >
                {t('addButton')}
              </Button>
            )}
          </>
        ) : (
          <>
            <UserDeniedIcon color="cartTextPrimary" />
            <VStack flex>
              <Text variant="lStrong" color="cartTextPrimary">
                {t('groupOrderLimitReached')}
              </Text>
              <Text variant="s" color="cartTextPrimary">
                {t('groupOrderLimitDescription')}
              </Text>
            </VStack>
          </>
        )}
      </HStack>
    </Card>
  );
});

AddAppointmentButtonCard.displayName = 'AddAppointmentButtonCard';
export { AddAppointmentButtonCard };
